import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import { LOGOUT_USER } from "./app/redux/constatnts/user_constants";
import { useHistory } from "react-router-dom";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

export const AppTopbar = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const confirm = (rowData) => {
    confirmDialog({
      message: "Do you want to Logout?",
      header: "Logout ",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-primary",
      rejectClassName: "p-button-danger",
      accept: () => logOut(),

      reject,
    });
  };
  const logOut = () => {
    dispatch({ type: LOGOUT_USER });
    history.push("/");
  };
  const reject = () => {};
  return (
    <div className="layout-topbar">
      <Link to="/" className="layout-topbar-logo">
        {/* <img src='assets/layout/images/gulberg-islamabad.png' alt="logo" /> */}

        <span className="">Parking System</span>
      </Link>

      <button
        type="button"
        className="p-link  layout-menu-button layout-topbar-button"
        onClick={props.onToggleMenuClick}
      >
        <i className="pi pi-bars" />
      </button>

      <button
        type="button"
        className="p-link layout-topbar-menu-button layout-topbar-button"
        onClick={props.onMobileTopbarMenuClick}
      >
        <i className="pi pi-ellipsis-v" />
      </button>

      <ul
        className={classNames("layout-topbar-menu lg:flex origin-top", {
          "layout-topbar-menu-mobile-active": props.mobileTopbarMenuActive,
        })}
      >
        <li>
          <button
            className="p-link layout-topbar-button"
            onClick={() => {
              confirm();
            }}
          >
            <i className="pi pi-sign-out" />
            <span>Profile</span>
          </button>
        </li>
      </ul>
    </div>
  );
};
